<script>
  export default {
    props: {
      item: Object,
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    methods: {
      classeVoltagem(valor, opcao) {
        return valor == opcao ? 'fa-check-circle-o' : 'fa-circle-o';
      }
    }
  }
</script>

<template>
    <div>
        <dl>
            <dt>Tipo de compra</dt>
            <dd>Equipamentos</dd>
        </dl>

        <dl v-if="item.projetoMetaEtapa !== null">
            <dt>Meta etapa</dt>
            <dd>{{ `${item.projetoMetaEtapa.meta.nome} - ${item.projetoMetaEtapa.etapa.nome}` }}</dd>
        </dl>

        <div class="row" v-if="item.rubrica !== null">
            <dl class="col-xs-6">
                <dt>Rubrica</dt>
                <dd>{{ item.rubrica.nome }}</dd>
            </dl>

            <dl class="col-xs-6">
                <dt>Subrubrica</dt>
                <dd>{{ item.subrubrica.nome }}</dd>
            </dl>
        </div>

        <div class="row" v-if="item.idTipoProduto > 0">
            <dl class="col-xs-12">
                <dt>Tipo de produto</dt>
                <dd>{{ item.tipoProduto ? item.tipoProduto.nomeTipoProduto : "---" }}</dd>
            </dl>
        </div>

        <div class="row" v-if="item.idProduto > 0">
            <dl class="col-xs-12">
                <dt>Produto</dt>
                <dd>{{ item.produto ? item.produto.nome : "---" }}</dd>
            </dl>
        </div>

        <dl>
            <dt>Descrição do material/serviço</dt>
            <dd class="white-space-pre">{{ item.descricao }}</dd>
        </dl>

        <div class="row">
            <dl :class="[configuracao.utilizarValorEstimado ? 'col-xs-6' : 'col-xs-12']">
                <dt>Quantidade</dt>
                <dd>{{ item.quantidade | fixar2digitos }}</dd>
            </dl>

            <dl class="col-xs-6" v-if="configuracao.utilizarValorEstimado">
                <dt>Valor estimado</dt>
                <dd>R$ {{ item.valorEstimado | fixar2digitos }}</dd>
            </dl>
        </div>

        <dl>
            <dt>Voltagem</dt>

            <dd class="row">
                <div class="col-xs-4">
                    <i class="fa" :class="classeVoltagem(item.voltagem, '110')"></i> 110v <br>
                </div>

                <div class="col-xs-4">
                    <i class="fa" :class="classeVoltagem(item.voltagem, '220')"></i> 220v <br>
                </div>

                <div class="col-xs-4">
                    <i class="fa" :class="classeVoltagem(item.voltagem, item.voltagem == '' ? '' : null)"></i> Não se aplica <br>
                </div>
            </dd>
        </dl>

        <h3 class="m-t m-b">Local que o material será alocado</h3>
        <div class="hr-line-dashed margin-top-5"></div>

        <div class="row">
            <dl class="col-sm-3">
                <dt>CEP</dt>
                <dd>{{ item.cepLocalAlocado || '---' }}</dd>
            </dl>
            <dl class="col-sm-6">
                <dt>Endereço</dt>
                <dd>{{ item.enderecoLocalAlocado || '---' }}</dd>
            </dl>
            <dl class="col-sm-3">
                <dt>Número</dt>
                <dd>{{ item.numeroLocalAlocado || '---' }}</dd>
            </dl>
        </div>

        <div class="row">
            <dl class="col-sm-2">
                <dt>Complemento</dt>
                <dd>{{ item.complementoLocalAlocado || '---' }}</dd>
            </dl>
            <dl class="col-sm-4">
                <dt>Bairro</dt>
                <dd>{{ item.bairroLocalAlocado || '---' }}</dd>
            </dl>
            <dl class="col-sm-4">
                <dt>Cidade</dt>
                <dd>{{ item.cidadeLocalAlocado || '---' }}</dd>
            </dl>
            <dl class="col-sm-2">
                <dt>Estado</dt>
                <dd>{{ item.estadoLocalAlocado || '---' }}</dd>
            </dl>
        </div>

        <div class="row">
            <dl class="col-sm-8">
                <dt>Unidade</dt>
                <dd>{{ item.unidadeLocalAlocado || '---' }}</dd>
            </dl>
            <dl class="col-sm-4">
                <dt>CNPJ Unidade</dt>
                <dd>{{ item.cnpjUnidadeLocalAlocado || '---' }}</dd>
            </dl>
        </div>

        <div class="hr-line-dashed"></div>

        <dl v-if="!configuracao.solCompraOcultarObservacoes">
            <dt>Observação do item de compra</dt>
            <dd class="white-space-pre">{{ item.observacaoItemCompra || '---' }}</dd>
        </dl>

        <dl>
            <dt>Objetivo/Justificativa da compra</dt>
            <dd class="white-space-pre">{{ item.objetivoCompra || '---' }}</dd>
        </dl>

        <dl>
            <dt>Local que o material será alocado</dt>
            <dd class="white-space-pre">{{ item.localAlocado || '---' }}</dd>
        </dl>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormListaEquipamentos.vue